export default "__VITE_ASSET__T3vb3ypv__"